<template>
  <section class="chartitem-wrapper" ref="chartContainer" />
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import * as echarts from 'echarts'

  const chartContainer = ref(null)

  const props = defineProps({
    options: {
      type: Object,
      defaultValue: {}
    }
  });

  const init = () => {
    const container = chartContainer.value
    if(!container) {
      console.error('no container');
      return;
    }

    if(!props?.options) {
      console.error('no options');
      return;
    }
    
    echarts.init(container).setOption({...props.options}, true)
  }
  onMounted(() => {
    init()
  })
  watch(() => [ props.options ], () => {
    init()
  }, { deep: true });
</script>

<style scoped lang="less">
@import "./index.less";
</style>
